import { useEffect } from "react";

import sub0102 from "../assets/sub0102-img01.jpg";

import AOS from "aos";
import "aos/dist/aos.css";

function History() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      offset: 100,
      easing: "ease-in-out",
      once: false,
    });

    window.addEventListener("scroll", () => {
      AOS.refresh();
    });
  }, []);

  return (
    <div>
      <section className="sec-wrap">
        <section className="sec-centent">
          <div id="sub" className="overview">
            <div className="col-a cont-wr">
              <div className="wr">
                <div className="cont-tit">
                  <h2 className="big">JENIX'S HISTORY</h2>
                  <p>
                    고객과의 인연을 소중히 하는 경영 철학을 체계화하며 더 큰 도약을 위한 마음가짐을 다졌습니다.
                    <br className="pc-only" />
                    사업의 핵심 역량을 기반으로 고객 가치를 높여가며 미래를 향한 제닉스의 힘찬 발걸음을 이어가겠습니다.
                    <br className="pc-only" />
                    그동안 수행한 프로젝트의 노하우를 바탕으로 미래를 향해 한걸음 더 나아가는 기업으로 성장하겠습니다.
                  </p>
                </div>
              </div>
              <div className="img center" data-aos="fade" data-aos-delay="100" data-aos-duration="500">
                <img src={sub0102} alt="도로이미지,길표현" />
              </div>
            </div>
            <div className="cont-wr">
              <div className="wr">
                <div className="cont-tit">
                  <h2>제닉스가 걸어온 길을 소개합니다.</h2>
                </div>
                <div className="tb-list">
                  <dl>
                    <dt>2024</dt>
                    <dd>
                      {/* <p>aT 농산물 온라인 도매시장(KAFB2B) 구축 사업 참여</p> */}
                      <p>농업경영종합정보시스템 위탁관리</p>
                      <p>온라인거래소 통합플랫폼 정산시스템 구축</p>
                      <p>정보보안 컨설팅 및 취약점 점검 7건 수행</p>
                    </dd>
                  </dl>
                  <dl>
                    <dt>2023</dt>
                    <dd>
                      {/* <p>aT 농산물 온라인 도매시장(KAFB2B) 구축 사업 참여</p> */}
                      <p>CJ 프레시웨이 FS 식단 관리프로그램 구축</p>
                      <p>삼성SDS 협력사 등록</p>
                      <p>본사 이전(영등포)</p>
                      <p>정보보안 컨설팅 및 취약점 점검 11건 수행</p>
                    </dd>
                  </dl>
                  <dl>
                    <dt>2022</dt>
                    <dd>
                      <p>aT 공공급식 통합 플랫폼 구축</p>
                      <p>aT 사이버거래 시스템 위탁운영</p>
                      <p>Azul Systems Reseller Partnership (JAVA)</p>
                      <p>kt ds 협력사 등록</p>
                      <p>정보 보안 컨설팅 및 취약점 점검 11건 수행</p>
                    </dd>
                  </dl>
                  <dl>
                    <dt>2021</dt>
                    <dd>
                      <p>aT 사이버거래 시스템 위탁운영</p>
                      <p>NDS 협력사 등록</p>
                      <p>특허 취득(블록체인 기반의 농수축산물 통합 유통 정보 플랫폼 제공을 위한 시스템)</p>
                      <p>정보 보안 컨설팅 및 취약점 점검 13건 수행</p>
                    </dd>
                  </dl>
                  <dl>
                    <dt>2020</dt>
                    <dd>
                      <p>대표이사 변경</p>
                      <p>aT 사이버거래 시스템 위탁운영</p>
                      <p>정보 보안 컨설팅 및 취약점 점검 6건 수행</p>
                    </dd>
                  </dl>
                  <dl>
                    <dt>2019</dt>
                    <dd>
                      <p>aT 학교급식지원센터 시스템 고도화 구축</p>
                      <p>한국농수산식품유통공사장 표창</p>
                      <p>본사 이전(가산디지털단지)</p>
                      <p>기업부설연구소 설립</p>
                    </dd>
                  </dl>
                  <dl>
                    <dt>2005~2018</dt>
                    <dd>
                      <p>
                        학교급식지원센터 통합 관리 시스템 2차, 사이버거래소 응용프로그램(사이버거래 시스템) 고도화 및 유지보수 외 39건의 SW 개발 및 유지 보수
                        사업 수행
                      </p>
                      <p>농림축산식품부 장관 표창(2013)</p>
                      <p>농림부 장관 표창(2007)</p>
                    </dd>
                  </dl>
                  <dl>
                    <dt>2004</dt>
                    <dd>
                      <p>주식회사 제닉스 설립(12월23일)</p>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
}

export default History;
